import React, { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSteeringWheel, faPlus } from '@fortawesome/pro-regular-svg-icons';
import Button from 'components/UI/V3/Button/Button';
import clsx from 'clsx';
import styles from './VehiclesIsEmpty.module.scss';

interface VehiclesIsEmptyProps {
    onClick: () => void;
    className?: string;
}

const VehiclesIsEmpty: FunctionComponent<VehiclesIsEmptyProps> = props => {
    return (
        <div className={clsx(styles.baseContainer, props.className)}>
            <div className={styles.wrapper}>
                <div className={clsx(styles.icon)}>
                    <FontAwesomeIcon
                        icon={faSteeringWheel}
                        aria-hidden="true"
                    />
                </div>
                <h1 className={clsx(styles.title)}>Vehicles</h1>
                <p className={clsx(styles.paragraph)}>
                    Click the &quot;Add New Vehicle&quot; button to add your first one
                </p>

                <div className={styles.buttonContainer}>
                    <Button
                        label="Add New Vehicle"
                        size="large"
                        variant="primary"
                        leftIcon={faPlus}
                        onClick={props.onClick}
                    />
                </div>
            </div>
        </div>
    );
};

export default VehiclesIsEmpty;
